/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import "../../styles/Instance.scss";
import { formatDateTime } from "../../utils/DatetimeFormat-table";

function TableLayout({
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setPageSort,
}) {
    const { sortBy } = state;
    const navigate = useNavigate();

    useEffect(() => {
        setPageSort(sortBy);
    }, [sortBy]);

    const onClick = (row) => {
        navigate(`/cart/edit/${row.original.cartId}`);
    };

    return (
        <div className="relative">
            <div className="block py-4 bg-[white] rounded-2xl shadow-soft-xl mt-4 dark:border-gray-700 dark:hover:bg-gray-700">
                <table
                    key="all-carts"
                    className="table-auto w-[100%]"
                    {...getTableProps()}
                >
                    <thead>
                        {headerGroups?.map((headerGroup, id) => (
                            <tr
                                {...headerGroup.getHeaderGroupProps()}
                                key={id}
                                className="text-left h-16 font-sans outline-1 border-b-2 border-gray-100"
                            >
                                {headerGroup.headers.map((column, id) => (
                                    <th
                                        className="pl-3 font-sans text-left"
                                        key={id}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        {column.render("Header")}
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? " ▼"
                                                    : " ▲"
                                                : ""}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="border-collapse">
                        {rows?.map((row, rowIndex) => {
                            prepareRow(row);
                            return (
                                <tr
                                    {...row.getRowProps()}
                                    className="text-left border-t border-gray-100 h-14 pl-3 font-sans hover:bg-slate-200 cursor-pointer"
                                    key={rowIndex}
                                    onClick={() => onClick(row)}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        if (cell.column.Header === "Cart ID") {
                                            return (
                                                <td
                                                    {...cell.getCellProps()}
                                                    className="pl-3 py-4 text-left font-sans underline text-elm-500 font-medium"
                                                    key={cellIndex}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        }
                                        if (cell.column.Header === "Status") {
                                            const statusColors = {
                                                CART_ACTIVE: "bg-green-100 text-green-700",
                                                CART_LOCKED: "bg-yellow-100 text-yellow-700",
                                                CART_ABANDONED: "bg-red-100 text-red-700",
                                                CART_PAID: "bg-blue-100 text-blue-700",
                                            };
                                            return (
                                                <td
                                                    {...cell.getCellProps()}
                                                    className="pl-3 py-4 text-left font-sans"
                                                    key={cellIndex}
                                                >
                                                    <span className={`px-2 py-1 rounded-md text-xs font-semibold ${statusColors[cell.value] || "bg-gray-100 text-gray-700"}`}>
                                                        {cell.value}
                                                    </span>
                                                </td>
                                            );
                                        }
                                        if (cell.column.Header === "Created") {
                                            return (
                                                <td
                                                    {...cell.getCellProps()}
                                                    className="pl-3 py-4 text-left font-sans"
                                                    key={cellIndex}
                                                >
                                                    {formatDateTime(cell.value)}
                                                </td>
                                            );
                                        }
                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                className="pl-3 py-4 text-left font-sans"
                                                key={cellIndex}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default React.memo(TableLayout);

TableLayout.propTypes = {
    getTableProps: PropTypes.any,
    getTableBodyProps: PropTypes.func.isRequired,
    headerGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    prepareRow: PropTypes.func.isRequired,
    state: PropTypes.objectOf(PropTypes.any),
    setPageSort: PropTypes.func,
};
